import axios from 'axios';
import { IProject } from '../../electrolyse-shared/interfaces';
import { API_PATHS } from '../../electrolyse-shared/api-paths';

export const useGetProject = () => {
  return {
    getProjectById: async (id: string) => {
      return (await axios.get<{ item: IProject }>(API_PATHS.GET_PROJECT.replace(':id', id))).data.item;
    },
  };
};
